<template>
  <el-dialog
    :visible.sync="refinanceModalShow"
    width="30%"
    @closed="$emit('close')"
    v-loading="loading"
  >
    <div class="row" slot="title">
      <div class="col-12">
        <h4 class="m-0">Refinance</h4>
        <small class="text-light-gold" v-if="closeout_business">{{
          closeout_business.name
        }}</small>
      </div>
    </div>
    <div class="row" v-if="statusCard == 1">
      <div class="col-12">
        <purchase-invoice-upload
          @continue="onContinue"
          :show-before="false"
          @back="statusCard = 2"
          :message="'Please upload your invoice to get started'"
        />
      </div>
    </div>
    <div class="row" v-if="statusCard == 2">
      <div class="col-12">
        <refinance-closeout-modal-form
          :closeout_purchases="closeout_purchases"
          :invoice_file="invoiceFile"
          :initial_closeout_form="closeoutForm"
          :show_closeouts="show_closeouts"
          @close="$emit('close')"
          @refresh="$emit('refresh')"
          @back="statusCard = 1"
        ></refinance-closeout-modal-form>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import PurchaseInvoiceUpload from "../frontend/views/business/modals/pages/PurchaseInvoiceUpload.vue";
import RefinanceCloseoutModalForm from "./RefinanceCloseoutModalForm.vue";
import Property from "../frontend/modelsPortal/Property";
import Business from "../frontend/modelsPortal/Business";
export default {
  components: { PurchaseInvoiceUpload, RefinanceCloseoutModalForm },
  props: {
    closeout_purchases: {
      type: Array,
    },
    closeout_business: {
      type: Object,
    },
    closeout_livestock_class_id: {
      type: Number,
    },
    show_closeouts: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {
      loading: false,
      refinanceModalShow: true,
      statusCard: 1,
      invoiceFile: [],
      properties: [],
      closeoutForm: {
        property_id: null,
        bill_due_date: null,
        reference_code: null,
        invoice_invoice_date: null,
        average_weight: null,
        line_items: [],
        open_head: 0,
        number_of_head: 0,
        livestock_class_id: this.closeout_livestock_class_id,
        business_id: this.closeout_business.id,
        purchase_type_id: 2, //refinance,
        type_id: 1, //type closeout refinance,
        settlement_date: null,
        error: false,
        message: "",
        purchase_ids: this.closeout_purchases.map(({ id }) => id),
      },
    };
  },
  mounted() {
    this.getProperties(this.closeout_business.id);
  },
  methods: {
    async getProperties(businessId) {
      try {
        const data = await new Property()
          .for(new Business({ id: businessId }))
          .params({ no_paginate: true })
          .get();

        this.properties = data;
      } catch (err) {
        console.error(err);
      }
    },
    onContinue(values) {
      this.invoiceFile = [];
      this.closeoutForm.line_items = [];
      if (values) {
        this.invoiceFile = [values.file];

        if (values.nominated_pic && this.properties) {
          console.log(this.properties);
          const property = this.properties.find(
            (property) => property.pic === values.nominated_pic,
          );

          if (property) this.closeoutForm.property_id = property.id;
        }

        this.closeoutForm.bill_due_date = values.due_date
          ? new Date(values.due_date)
          : null;

        this.closeoutForm.invoice_invoice_date = values.invoice_date
          ? new Date(values.invoice_date)
          : null;

        this.closeoutForm.reference_code = values.reference_code || null;

        this.closeoutForm.bill_invoice_date = values.invoice_date
          ? new Date(values.invoice_date)
          : null;
      }
      let self = this;
      this.closeout_purchases.forEach((item, index) => {
        self.closeoutForm.open_head = self.closeout_purchases.reduce(
          (prev, curr) => prev + Number(curr.on_pic),
          0,
        );
        self.closeoutForm.number_of_head = self.closeoutForm.open_head;
        self.closeoutForm.line_items.push({
          closeout_purchase_id: item.id,
          average_weight: 0,
          curr_average_weight: item.average_weight,
          description: `RF - ${item.ref_id}`,
          quantity: item.on_pic,
          livestock_class_id: self.closeout_livestock_class_id,
          total_ex_gst: 0,
          price_per_kg_ex: 0,
          price_per_head_ex_gst: 0,
          sex_id: null,
          breed_category_id: null,
          gst: 1,
        });
      });
      this.statusCard = 2;
    },
  },
};
</script>
